import { createBrowserRouter, Navigate, Outlet } from "react-router-dom";

// pages=========
import App from "../App";
import PageNotFound from "../pages/pageNotFound/PageNotFound";
import Home from "../pages/home/Home";
import Terms from "../pages/terms/Terms";
import Goldify from "../pages/Goldpage/Goldify";
import Products from "../pages/products/Products";
import ProductDetails from "../pages/productDetails/ProductDetails";
import ShippingAddress from "../pages/ShippingAddress/ShippingAddress";
import Confirmation from "../pages/Goldpage/Confirmation";
import BuySummary from "../pages/buySummary/BuySummary";
import Invoice from "../pages/Goldpage/invoice";
import SilverInvoice from "../pages/Silvify/invoice";
import GoldSoldInvoice from "../pages/Goldpage/GoldSoldInvoice";
import SilverSoldInvoice from "../pages/Silvify/GoldSoldInvoice";
import Silvify from "../pages/Silvify/Silvify";
import HistoryInvoice from "../pages/historyInvoice";
import Portfolio from "../pages/Portfolio";
import Profile from "../pages/Profile/Profile";
import ProfileSetting from "../pages/Profile/ProfileSetting";
import CustomGoldAndSilverSip from "../pages/customGoldAndSilverSip/CustomGoldAndSilverSip";
import SipHistory from "../pages/sipHistory/SipHistory";
import SipHistoryDetails from "../pages/sipHistoryDetails/SipHistoryDetails";
import Report from "../pages/report/Report";
import Dashboard from "../pages/Dashboard/Dashboard";
import GoldShell from "../pages/Goldpage/goldsellsummary";
import SilverShell from "../pages/Silvify/goldsellsummary";
import SellSummary from "../pages/sellSummary/SellSummary";
import Login from "../pages/login/Login";
import Account from "../pages/account/Account";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import History from "../pages/history";
import RefundPolicy from "../pages/refundPolicy/RefundPolicy";
import CancelPolicy from "../pages/cancelPolicy/CancelPolicy";
import ShippingPolicy from "../pages/shippingPolicy/ShippingPolicy";

const ProtectedRoute = () => {
  const token = sessionStorage.getItem("token");
  return token ? (
    <Dashboard>
      <Outlet />
    </Dashboard>
  ) : (
    <Navigate to="/login" replace />
  );
};

const PublicRoute = () => {
  const token = sessionStorage.getItem("token");
  return token ? <Navigate to="/account" replace /> : <Outlet />;
};

const Router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <PageNotFound />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "login",
        element: <PublicRoute />,
        children: [{ index: true, element: <Login /> }],
      },
      {
        path: "privacy-policy",
        element: <PrivacyPolicy />,
      },
      {
        path: "refund-policy",
        element: <RefundPolicy />,
      },
      {
        path: "shipping-policy",
        element: <ShippingPolicy />,
      },
      {
        path: "cancellation-policy",
        element: <CancelPolicy />,
      },
      {
        path: "terms-conditions",
        element: <Terms />,
      },
      {
        path: "account",
        element: <Account />,
      },
      // DASHBOARD========
      {
        path: "dashboard",
        element: <ProtectedRoute />,
        children: [
          {
            index: true,
            element: <Account />,
          },
          {
            path: "buygold",
            element: <Goldify />,
          },
          // =====================================================
          {
            path: "gold",
            element: <Goldify />,
            children: [
              { index: true, element: <Navigate to="buy" replace /> },
              { path: "buy", element: <div /> },
              { path: "sell", element: <div /> },
              { path: "delivery", element: <div /> },
              { path: "sip", element: <div /> },
            ],
          },
          {
            path: "gold/delivery/:id",
            element: <ProductDetails />,
          },
          {
            path: "silver",
            element: <Silvify />,
            children: [
              { index: true, element: <Navigate to="buy" replace /> },
              { path: "buy", element: <div /> },
              { path: "sell", element: <div /> },
              { path: "delivery", element: <div /> },
              { path: "sip", element: <div /> },
            ],
          },
          {
            path: "silver/delivery/:id",
            element: <ProductDetails />,
          },

          // =====================================================
          {
            path: "products",
            element: <Products />,
          },
          {
            path: "productDetails",
            element: <ProductDetails />,
          },
          {
            path: "shippingAddress",
            element: <ShippingAddress />,
          },
          {
            path: "confirmation",
            element: <Confirmation />,
          },
          {
            path: "gold-buy-Summary",
            element: <BuySummary />,
          },
          {
            path: "invoice",
            element: <Invoice />,
          },
          {
            path: "silverinvoice",
            element: <SilverInvoice />,
          },
          // {
          //   path: "goldsellsummary",
          //   element: <GoldShell />,
          // },
          // {
          //   path: "silversellsummary",
          //   element: <SilverShell />,
          // },
          {
            path: "gold-sell-summary",
            element: <SellSummary />,
          },
          {
            path: "silver-sell-summary",
            element: <SellSummary />,
          },

          {
            path: "goldSoldInvoice",
            element: <GoldSoldInvoice />,
          },
          {
            path: "silverSoldInvoice",
            element: <SilverSoldInvoice />,
          },
          // ==================== SILVER ROUTES==============================
          {
            path: "buysilver",
            element: <Silvify />,
            children: [
              {
                path: "products",
                element: <Products />,
              },
            ],
          },
          {
            path: "silver-buy-Summary",
            element: <BuySummary />,
          },
          // ==== HISTORY ROUTES=======

          {
            path: "history",
            children: [
              {
                index: true,
                element: <History />,
              },
              {
                path: ":id",
                // path: "invoice",
                element: <HistoryInvoice />,
              },
            ],
          },
          // {
          //   path: "history",
          //   element: <HistoryPortfolio />,
          // },
          // {
          //   path: "historyinvoice",
          //   element: <HistoryInvoice />,
          // },
          {
            path: "portfolio",
            element: <Portfolio />,
          },
          // ================PROFILE===========
          {
            path: "profile",
            children: [
              {
                index: true,
                element: <Profile />,
              },
              {
                path: "profileSetting",
                element: <ProfileSetting />,
              },
              {
                path: "report",
                element: <Report />,
              },
              {
                path: "sip-history",
                children: [
                  {
                    index: true,
                    element: <SipHistory />,
                  },
                  {
                    path: ":sipId",
                    element: <SipHistoryDetails />,
                  },
                ],
              },
            ],
          },

          // {
          //   path: "profile",
          //   element: <Profile />,
          // },
          // {
          //   path: "ProfileSetting",
          //   element: <ProfileSetting />,
          // },
          // {
          //   path: "sip-history",
          //   element: <SipHistory />,
          // },
          // {
          //   path: ":sipId",
          //   element: <SipHistoryDetails />,
          // },
          // {
          //   path: "report",
          //   element: <Report />,
          // },
        ],
      },
    ],
  },
]);

export default Router;
